import OutlineTen from '@assets/icons/outline-ten.svg'
import { Icon } from './Icon'

export const OutlineTenIcon = Icon(OutlineTen)
